/**
 * View component for /transitions/:transitionId
 *
 * Displays a single transition from the 'byId' map in the transition reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as transitionActions from '../transitionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import transition components
import TransitionLayout from '../components/TransitionLayout.js.jsx';

// import transition css modules
import transitionStyles from '../transitionModuleStyles.css';


class SingleTransition extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(transitionActions.fetchSingleIfNeeded(match.params.transitionId));
  }

  render() {
    const { transitionStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual transition object from the map
     */
    const selectedTransition = transitionStore.selected.getItem();

    const isEmpty = (
      !selectedTransition
      || !selectedTransition._id
      || transitionStore.selected.didInvalidate
    );

    return (
      <TransitionLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single Transition </h3>
              {isEmpty ?
                (transitionStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: transitionStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedTransition.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Transition </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the Transition would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </TransitionLayout>
    )
  }
}

SingleTransition.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    transitionStore: store.transition
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleTransition)
);



// WEBPACK FOOTER //
// modules/transition/views/SingleTransition.js.jsx